<template>
    <div>
        <!-- 标题 -->
        <div class="redshift-title">
            <Breadcrumb>
                <BreadcrumbItem>{{this.$route.query.accountTypeName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.accountName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.name}}</BreadcrumbItem>
                <BreadcrumbItem to="/monitor/redshiftMonitor">{{ $t('RedshiftMonitor.redshift') }}</BreadcrumbItem>
                <BreadcrumbItem>
                    <a @click="ipAddress">{{ $t('alarms.common.monitoringSummary') }}</a>
                </BreadcrumbItem>
            </Breadcrumb>
        </div>
        <!-- 查询框 -->
        <div class="redshift-top">
            <Row :gutter="16">
                <Col span="8">
                    <Select v-model="timeType" @on-change="changeTimeTypeAzure(timeType)">
                        <Option v-for="item in timeList" :value="item.id" :key="item.id">{{item.name}}</Option>
                    </Select>
                </Col>
            </Row>
        </div>
        <!-- 折线图 -->
        <Row :gutter="16">
            <Col span="8" v-for="(item,index) in list" :key="index">
                <Card :padding="8">
                    <p slot="title">{{item.title}}</p>
                    <a href="#" slot="extra" @click.prevent="changeFull(item)">
                        <Icon type="ios-expand" size="18"/>
                    </a>
                    <div :id="item.id" :ref="item.id" style="width:100%;height: 240px;"></div>
                </Card>
            </Col>
        </Row>
        <!-- 放大弹出框 -->
        <Modal v-model="isShowModal" :mask-closable="false" :closable="false" width="65%">
            <Row>
                <Col span="24">
                    <h3>{{lineTitle}}</h3>
                    <div id="chart-part" ref="fullChart" style="width:100%; height:420px;"></div>
                </Col>
            </Row>
            <div slot="footer">
                <div>
                    <Button @click="cancel">{{$t('alarms.common.close')}}</Button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    export default {
        name: 'Redshift',
        data () {
            return {
                // 放大功能
                lineTitle:'',
                isShowModal: false,
                // 折线图
                list: [{
                    id: 'percentageDiskSpaceUseds',
                    title:this.$t('RedshiftMonitor.line.PercentageOfUsedDiskSpacePercentage')
                },
                {
                    id: 'healthStatus',
                    title:this.$t('RedshiftMonitor.line.HealthStatus')
                },
                {
                    id: 'maintenanceModes',
                    title:this.$t('RedshiftMonitor.line.MaintenanceMode')
                },
                {
                    id: 'cpuUtilizations',
                    title:this.$t('RedshiftMonitor.line.ClusterCPUUsagePercentage')
                },
                {
                    id: 'databaseConnections',
                    title:this.$t('RedshiftMonitor.line.NumberOfClusterConnectionstimessecond')
                },
                {
                    id: 'writeReadIOPS',
                    title:this.$t('RedshiftMonitor.line.ClusterReadAndWriteIOPStimessecond')
                }],
                timeType:0,
                timeList:[],
                id:'',
                accountId:'',
                accountTypeName:'',
                accountName:'',
                region:'',
                // echarts实例
                chartPercentageDiskSpaceUsed:'',
                chartHealthStatus:'',
                chartMaintenanceMode:'',
                chartCpuUtilization:'',
                chartDatabaseConnections:'',
                chartWriteReadIOPS:'',
                percentageDiskSpaceUsedsOption:{},
                healthStatusOption:{},
                maintenanceModesOption:{},
                cpuUtilizationsOption:{},
                databaseConnectionsOption:{},
                writeReadIOPSOption:{},
                //AWS数组
                cpuUtilization:[],
                databaseConnections:[],
                healthStatus:[],
                maintenanceMode:[],
                percentageDiskSpaceUsed:[],
                readIOPS:[],
                writeIOPS:[],
                xaxisData:[]
            }
        },
        mounted: function(){
            this.queryTimeHorizon();
            // 自适应不同屏幕尺寸
            const self=this;
            window.addEventListener("resize",function(){
                self.chartPercentageDiskSpaceUsed.resize();
                self.chartHealthStatus.resize();
                self.chartMaintenanceMode.resize();
                self.chartCpuUtilization.resize();
                self.chartDatabaseConnections.resize();
                self.chartWriteReadIOPS.resize();
            });
        },
        created(){
            this.checkAWSRedshiftStatistics();
        },
        methods: {
            /******************放大********************************/
            changeFull:function(item){
                this.isShowModal=true;
                this.lineTitle=item.title;
                this.$nextTick(() => {
                    const chartFul = this.$refs.fullChart;
                    if(chartFul){
                        const fullChart = this.$echarts.init(
                            document.getElementById("chart-part")
                        );
                        fullChart.clear();
                        if(item.id=='percentageDiskSpaceUseds'){
                            var optionFll = this.percentageDiskSpaceUsedsOption;
                        }else if(item.id=='healthStatus'){
                            var optionFll = this.healthStatusOption;
                        }else if(item.id=='maintenanceModes'){
                            var optionFll = this.maintenanceModesOption;
                        }else if(item.id=='cpuUtilizations'){
                            var optionFll = this.cpuUtilizationsOption;
                        }else if(item.id=='databaseConnections'){
                            var optionFll = this.databaseConnectionsOption;
                        }else if(item.id=='writeReadIOPS'){
                            var optionFll = this.writeReadIOPSOption;
                        }
                        
                        fullChart.setOption(optionFll);
                        window.addEventListener("resize", function() {
                            fullChart.resize();
                        });    
                    }
                });
            },
            // 模态框取消事件
            cancel() {
                this.isShowModal = false;
            },
            /******************查询********************************/
            // 查询时间范围
            queryTimeHorizon: function(){
                this.$api.cloudWatch.queryTimeHorizon("userName",getCookie(global.cookieName))
                .then(res => {
                    this.timeList = res.data;
                })
            },
            // Aws折线图
            checkAWSRedshiftStatistics: function(){
                this.$api.cloudWatch.checkAWSRedshiftStatistics({
                    "accountId":this.$route.query.accountId,
                    "timeHorizon":this.timeType,
                    "region":this.$route.query.region,
                    "clusterIdentifier":this.$route.query.name
                })
                .then(res => {
                    this.xaxisData=res.data.xaxisData;
                    this.cpuUtilization=res.data.cpuUtilization;
                    this.databaseConnections=res.data.databaseConnections;
                    this.healthStatus=res.data.healthStatus;
                    this.maintenanceMode=res.data.maintenanceMode;
                    this.percentageDiskSpaceUsed=res.data.percentageDiskSpaceUsed;
                    this.readIOPS=res.data.readIOPS;
                    this.writeIOPS=res.data.writeIOPS;
                    this.allAws();
                })
            },
            changeTimeTypeAzure:function(){
                this.checkAWSRedshiftStatistics();
            },
            /******************所有折线图********************************/
            allAws:function(){
                this.percentageDiskSpaceUsedLine();
                this.healthStatusLine();
                this.maintenanceModeLine();
                this.cpuUtilizationsLine();
                this.databaseConnectionsLine();          
                this.writeReadIOPSLine();
            },
            /*************折线图*****************************/
            // 已使用磁盘空间的百分比（%）
            percentageDiskSpaceUsedLine:function(){
                this.chartPercentageDiskSpaceUsed=this.$echarts.init(document.getElementById("percentageDiskSpaceUseds"));
                this.percentageDiskSpaceUsedsOption={
                    tooltip : {
                        trigger: 'axis',
                        confine: true,
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    // 已使用磁盘空间的百分比
                    legend: {
                        x: 'right',
                        y: '10px',
                        data:[this.$t('RedshiftMonitor.line.PercentageOfUsedDiskSpace')]
                    },
                    series: [{
                        name:this.$t('RedshiftMonitor.line.PercentageOfUsedDiskSpace'),
                        type:'line',
                        data:this.percentageDiskSpaceUsed,
                        itemStyle: {
                            normal: {
                                color: "#91c7ae",
                                lineStyle: {
                                    color: "#91c7ae"
                                }
                            }
                        }
                    }],
                    grid: {
                        top:'20%',
                        left: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [
                        {
                            type : 'category',
                            boundaryGap : false,
                            data: this.xaxisData.map(function (str) {
                                return str.replace(' ', '\n')
                            })
                        }
                    ],
                    yAxis : [
                        {
                            splitNumber:4,
                            type : 'value'
                        }
                    ]
                }
                this.chartPercentageDiskSpaceUsed.setOption(this.percentageDiskSpaceUsedsOption)
            },
             // 健康状态
            healthStatusLine:function(){
                this.chartHealthStatus=this.$echarts.init(document.getElementById("healthStatus"));
                this.healthStatusOption={
                    tooltip : {
                        trigger: 'axis',
                        confine: true,
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    // 健康状态
                    legend: {
                        x: 'right',
                        y: '10px',
                        data:[this.$t('RedshiftMonitor.line.HealthStatus')]
                    },
                    series: [{
                        name:this.$t('RedshiftMonitor.line.HealthStatus'),
                        type:'line',
                        data:this.healthStatus,
                        itemStyle: {
                            normal: {
                                color: "#ceca58",
                                lineStyle: {
                                    color: "#ceca58"
                                }
                            }
                        }
                    }],
                    grid: {
                        top:'20%',
                        left: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [
                        {
                            type : 'category',
                            boundaryGap : false,
                            data: this.xaxisData.map(function (str) {
                                return str.replace(' ', '\n')
                            })
                        }
                    ],
                    yAxis : [
                        {
                            splitNumber:4,
                            type : 'value'
                        }
                    ]
                }
                this.chartHealthStatus.setOption(this.healthStatusOption)
            },
             // 维护模式
            maintenanceModeLine:function(){
                this.chartMaintenanceMode=this.$echarts.init(document.getElementById("maintenanceModes"));
                this.maintenanceModesOption={
                    tooltip : {
                        trigger: 'axis',
                        confine: true,
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    // 维护模式
                    legend: {
                        x: 'right',
                        y: '10px',
                        data:[this.$t('RedshiftMonitor.line.MaintenanceMode')]
                    },
                    series: [{
                        name:this.$t('RedshiftMonitor.line.MaintenanceMode'),
                        type:'line',
                        data:this.maintenanceMode,
                        itemStyle: {
                            normal: {
                                color: "#ccc",
                                lineStyle: {
                                    color: "#ccc"
                                }
                            }
                        }
                    }],
                    grid: {
                        top:'20%',
                        left: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [
                        {
                            type : 'category',
                            boundaryGap : false,
                            data: this.xaxisData.map(function (str) {
                                return str.replace(' ', '\n')
                            })
                        }
                    ],
                    yAxis : [
                        {
                            splitNumber:4,
                            type : 'value'
                        }
                    ]
                }
                this.chartMaintenanceMode.setOption(this.maintenanceModesOption)
            },
             // 集群CPU使用率(%)
            cpuUtilizationsLine:function(){
                this.chartCpuUtilization=this.$echarts.init(document.getElementById("cpuUtilizations"));
                this.cpuUtilizationsOption={
                    tooltip : {
                        trigger: 'axis',
                        confine: true,
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    // 集群CPU使用率
                    legend: {
                        x: 'right',
                        y: '10px',
                        data:[this.$t('RedshiftMonitor.line.ClusterCPUUsage')]
                    },
                    series: [{
                        name:this.$t('RedshiftMonitor.line.ClusterCPUUsage'),
                        type:'line',
                        data:this.cpuUtilization,
                        itemStyle: {
                            normal: {
                                color: "#7f4554",
                                lineStyle: {
                                    color: "#7f4554"
                                }
                            }
                        }
                    }],
                    grid: {
                        top:'20%',
                        left: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [
                        {
                            type : 'category',
                            boundaryGap : false,
                            data: this.xaxisData.map(function (str) {
                                return str.replace(' ', '\n')
                            })
                        }
                    ],
                    yAxis : [
                        {
                            splitNumber:4,
                            type : 'value'
                        }
                    ]
                }
                this.chartCpuUtilization.setOption(this.cpuUtilizationsOption)
            },
             // 集群连接数(次数/秒)
            databaseConnectionsLine:function(){
                this.chartDatabaseConnections=this.$echarts.init(document.getElementById("databaseConnections"));
                this.databaseConnectionsOption={
                    tooltip : {
                        trigger: 'axis',
                        confine: true,
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    // 集群连接数
                    legend: {
                        x: 'right',
                        y: '10px',
                        data:[this.$t('RedshiftMonitor.line.NumberOfClusterConnections')]
                    },
                    series: [{
                        name:this.$t('RedshiftMonitor.line.NumberOfClusterConnections'),
                        type:'line',
                        data:this.databaseConnections,
                        itemStyle: {
                            normal: {
                                color: "#61a0a8",
                                lineStyle: {
                                    color: "#61a0a8"
                                }
                            }
                        }
                    }],
                    grid: {
                        top:'20%',
                        left: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [
                        {
                            type : 'category',
                            boundaryGap : false,
                            data: this.xaxisData.map(function (str) {
                                return str.replace(' ', '\n')
                            })
                        }
                    ],
                    yAxis : [
                        {
                            splitNumber:4,
                            type : 'value'
                        }
                    ]
                }
                this.chartDatabaseConnections.setOption(this.databaseConnectionsOption)
            },
            // 集群读写IOPS (次数/秒)
            writeReadIOPSLine:function(){
                this.chartWriteReadIOPS=this.$echarts.init(document.getElementById("writeReadIOPS"));
                this.writeReadIOPSOption={
                     tooltip : {
                        trigger: 'axis',
                        confine: true,
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    // 集群读IOPS 集群写IOPS
                    legend: {
                        x: 'right',
                        y: '10px',
                        data:[this.$t('RedshiftMonitor.line.ClusterReadIOPS'),this.$t('RedshiftMonitor.line.ClusterWriteIOPS')]
                    },
                    series: [{
                        name:this.$t('RedshiftMonitor.line.ClusterReadIOPS'),
                        type:'line',
                        data:this.readIOPS,
                        itemStyle: {
                            normal: {
                                color: "#803500",
                                lineStyle: {
                                    color: "#803500"
                                }
                            }
                        }
                    },{
                        name:this.$t('RedshiftMonitor.line.ClusterWriteIOPS'),
                        type:'line',
                        data:this.writeIOPS,
                        itemStyle: {
                            normal: {
                                color: "#FF9B40",
                                lineStyle: {
                                    color: "#FF9B40"
                                }
                            }
                        }
                    }],
                    grid: {
                        top:'20%',
                        left: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [
                        {
                            type : 'category',
                            boundaryGap : false,
                            data: this.xaxisData.map(function (str) {
                                return str.replace(' ', '\n')
                            })
                        }
                    ],
                    yAxis : [
                        {
                            splitNumber:4,
                            type : 'value'
                        }
                    ]
                }
                this.chartWriteReadIOPS.setOption(this.writeReadIOPSOption)
            },
            /********************************/
            // 点击返回详情页
            ipAddress: function(){
                this.id = this.$route.query.id;
                this.accountId=this.$route.query.accountId;
                this.region=this.$route.query.region;
                this.accountTypeName=this.$route.query.accountTypeName;
                this.accountName=this.$route.query.accountName;
                this.name=this.$route.query.name;
                this.$router.push({path:'/monitor/redshiftDetail/',query: {id: this.id,accountId:this.accountId,region:this.region,accountTypeName:this.accountTypeName,accountName:this.accountName,name:this.name}});
            }
        }
    }
</script>

<style scoped>
    .redshift-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 15px 4px;
        font-weight: 600;
    }
    .ivu-col-span-8
    {
        margin-bottom: 20px;
    }
    .redshift-top
    {
        width: 100%;
        height: 53px;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/redshift/redshift_dashboard/Redshift.vue